export const getSnackbarStyles = ({ variant }) => ({
  position: 'relative',
  width: 'fit-content',

  '&:after': {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: '-2px',
    width: '16px',
    content: '""',
    backgroundColor: ({ palette }) => `${palette[variant]?.dark}`,
    borderRadius: ({ shape }) => shape.radius.l,
    animation: 'fadeIn 0.5s ease-in-out',
    zIndex: 0,
  },
});

export const getAlertStyles = ({ variant }) => ({
  display: 'flex',
  maxWidth: '820px',
  padding: '16px',
  transform: 'translateX(2px) !important',
  borderRadius: ({ shape }) =>
    `${shape.radius.s} ${shape.radius.l} ${shape.radius.l} ${shape.radius.s}`,
  // Light: a pale variant-tinted pill (extraSoft) with dark-variant text. In dark that pale fill +
  // white body text is unreadable, so use a dark elevated surface with a variant-colored border and
  // light text instead.
  backgroundColor: ({ palette }) =>
    palette.mode === 'dark' ? palette.background.paper : palette[variant]?.extraSoft,
  border: ({ palette }) =>
    palette.mode === 'dark' ? `1px solid ${palette[variant]?.main}` : 'none',
  color: ({ palette }) => (palette.mode === 'dark' ? palette.text.primary : palette[variant]?.dark),
  boxShadow: ({ palette }) => palette.shadow.s,
  zIndex: 1,

  '& > *': {
    padding: '0 !important',
    margin: '0 !important',
    color: ({ palette }) =>
      `${palette.mode === 'dark' ? palette.text.primary : palette[variant]?.dark} !important`,
  },

  '& .MuiAlert-message': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '8px',
    margin: '0 16px 0 8px !important',
    overflow: 'hidden',
  },
});

export const actionsContainerStyles = {
  display: 'flex',
  gap: '8px',
};

export const actionButtonStyles = {
  minWidth: 'unset',
  height: '24px',
  padding: '0 8px !important',
};

export const getCloseButtonStyles = ({ variant }) => ({
  color: ({ palette }) => palette[variant]?.dark,

  '&:hover, &:focus': {
    backgroundColor: ({ palette }) => palette[variant]?.soft,
  },
});
